export enum PredefinedContentPageRowEnum {
    EMPTY = 'EMPTY',
}
